import { useLoggingLazyQuery } from 'lib/apollo/apollo-hooks';
import type {
  GetActivitiesChangesQuery,
  GetActivitiesChangesQueryVariables,
} from './settings-publish.graphql.generated';
import { GET_ACTIVITIES_CHANGES } from './settings-publish.graphql';

const useGetLazyActivitiesChanges = (props?: { onError?: () => void }) => {
  const [getActivitiesChanges, { loading }] = useLoggingLazyQuery<
    GetActivitiesChangesQuery,
    GetActivitiesChangesQueryVariables
  >(GET_ACTIVITIES_CHANGES, {
    onError: () => {
      props?.onError?.();
    },
  });

  return { getActivitiesChanges, loading };
};

export default useGetLazyActivitiesChanges;
